function imageSliderFn() {
	// JavaScript to be fired on the home page, after the init JS
	//var before = document.querySelector('#options-peek-before')
	//var after = document.querySelector('#options-peek-after')


	var fullSliders = document.querySelectorAll('.glide-full');

	for (var i = 0; i < fullSliders.length; i++) {
		console.log('fullSlider');
		var glideFull = new Glide(fullSliders[i], {
			type: 'carousel',
			perView: 1,
			gap: 0,
			dragThreshold: false,
			autoplay: 3000

		})

		glideFull.mount();

		console.log(glideFull);
	}

	var glideSliders = document.querySelectorAll('.glide');

	for (var i = 0; i < glideSliders.length; i++) {

		console.log('glide3');
		var glide = new Glide(glideSliders[i], {
			type: 'carousel',
			startAt: 1,
			perView: 3,
			dragThreshold: false,
			animationDuration: 50,
			breakpoints: {
				767: {
					perView: 1
				}
			}

		})

		glide.mount();


		console.log(glide);

		glide.on('move.after', function (moveAmount) {

			$('.image-slider-prev').removeClass('image-slider-prev');
			$('.image-slider-next').removeClass('image-slider-next');
			$('.image-slider-active').removeClass('image-slider-active');
			$('.image-slider__slides .glide__slide--active').addClass('image-slider-prev');
			$('.image-slider__slides .glide__slide--active').next().addClass('image-slider-active');
			$('.image-slider__slides .glide__slide--active').next().next().addClass('image-slider-next');

		});
	}
	
	
	

}

const imageSlider = {
	init: function () {
		imageSliderFn();
	},
};

export default imageSlider;

